import applicant from './applicant-ms'
import archive from './archive-ms'
import calendar from './calendar-ms'
import dashboard from './dashboard-ms'
import drawing from './drawing-ms'
import exportStrings from './export-ms'
import findings from './findings-ms'
import history from './history-ms'
import importStrings from './import-ms'
import intakeStrings from './intake-ms'
import km from './km-ms'
import lettersStrings from './letters-ms'
import notificationStrings from './notifications-ms'
import oscStrings from './osc-ms'
import pages from './pages-ms'
import procedure from './procedure-ms'
import queueStrings from './queue-ms'
import registerExportStrings from './register-export-ms'
import registerPublic from './register-public-ms'
import registrations from './registrations-ms'
import settings from './settings-ms'
import trustStrings from './trust-ms'
import workflowStrings from './workflow-ms'

/** Teks konsol modul Perancangan (Kebenaran Merancang). Status senarai ialah istilah statutori. */
export default {
  home: {
    title: 'Kebenaran Merancang',
    subtitle: 'Penyerahan pelan, semakan dan kelulusan akan dipaparkan di sini.',
  },
  settings,
  findings,
  form: { ...pages.form, ...km.form },
  report: pages.report,
  detail: pages.detail,
  dashboard: dashboard.dashboard,
  activity: dashboard.activity,
  registrations,
  mySubmissions: applicant.mySubmissions,
  downloads: applicant.downloads,
  history: history.history,
  chain: history.chain,
  calendar: calendar.calendar,
  clocks: { ...calendar.clocks, names: km.clocks },
  procedure: procedure.procedure,
  roles: procedure.roles,
  export: exportStrings.export,
  authority: exportStrings.authority,
  sealKey: exportStrings.sealKey,
  archive: archive.archive,
  imports: importStrings.imports,
  queue: queueStrings.queue,
  trustedSystems: trustStrings.trustedSystems,
  externalIds: trustStrings.externalIds,
  osc: oscStrings.osc,
  workflow: workflowStrings.workflow,
  intake: intakeStrings.intake,
  inputs: km.inputs,
  flags: km.flags,
  counters: km.counters,
  drawingStandard: drawing.drawingStandard,
  findingHelp: drawing.findingHelp,
  nextStep: drawing.nextStep,
  checkWording: drawing.checkWording,
  placement: drawing.placement,
  cleanup: drawing.cleanup,
  registerExport: registerExportStrings.registerExport,
  notifications: notificationStrings.notifications,
  letters: lettersStrings.letters,
  copyFailed: 'Gagal menyalin: pilih teks itu dan salin sendiri.',
  list: {
    subtitle: 'Penyerahan pelan, semakan lukisan dan kelulusannya.',
    newSubmission: 'Penyerahan baharu',
    searchLabel: 'Cari penyerahan',
    searchPlaceholder: 'Rujukan, nama projek, pemohon atau nama fail',
    search: 'Cari',
    tabsLabel: 'Tapis penyerahan',
    tabs: {
      all: 'Semua',
      awaiting: 'Menunggu semakan',
      approved: 'Diluluskan',
      returned: 'Dikembalikan',
      failed: 'Gagal',
      withdrawn: 'Ditarik balik',
      committee: 'Di jawatankuasa',
      refused: 'Ditolak',
      in_force: 'Berkuat kuasa',
    },
    columns: {
      title: 'Nama projek',
      applicant: 'Pemohon',
      file: 'Fail',
      size: 'Saiz',
      conversion: 'Semakan lukisan',
      approval: 'Kelulusan',
      updated: 'Dikemas kini',
      actions: 'Tindakan',
    },
    view: 'Lihat',
    empty: 'Belum ada penyerahan.',
    emptyFiltered: 'Tiada penyerahan sepadan dengan tapisan ini.',
    pageOf: 'Halaman {{page}} daripada {{pages}}',
    previous: 'Sebelumnya',
    next: 'Seterusnya',
    total: 'Penyerahan: {{total}}',
  },
  status: {
    none: '—',
    conversion: { in_progress: 'Dalam Proses', done: 'Selesai', failed: 'Gagal' },
    approval: {
      awaiting: 'Menunggu Kelulusan',
      approved: 'Diluluskan',
      returned: 'Dikembalikan',
      withdrawn: 'Ditarik Balik',
      refused: 'Ditolak',
      lapsed: 'Luput',
    },
  },
  stage: {
    draft: 'Draf',
    checking: 'Sedang disemak',
    check_failed: 'Semakan gagal',
    awaiting_review: 'Menunggu semakan',
    approved: 'Diluluskan',
    returned: 'Dikembalikan',
    withdrawn: 'Ditarik balik',
    deleted: 'Dipadam',
    ...km.stage,
  },
  submissionStatus: {
    queued: 'Dalam giliran',
    converting: 'Sedang ditukar',
    ingesting: 'Sedang dimuatkan',
    passed: 'Lulus',
    passed_with_warnings: 'Lulus dengan amaran',
    failed: 'Gagal',
    error: 'Ralat',
  },
  severity: { fail: 'Kegagalan', warn: 'Amaran', info: 'Catatan' },
  result: { passed: 'Semakan lulus', passed_with_warnings: 'Semakan lulus dengan amaran', failed: 'Semakan gagal' },
  actions: {
    submit: 'Hantar',
    check_retry: 'Cuba semak semula',
    resubmit: 'Hantar semula',
    approve: 'Luluskan',
    return: 'Kembalikan',
    withdraw: 'Tarik balik',
    delete: 'Padam',
    check_passed: 'Semakan lulus',
    check_failed: 'Semakan gagal',
    check_errored: 'Semakan tidak dapat dijalankan',
    ...km.actions,
  },
  actionConfirm: {
    approve: 'Luluskan penyerahan ini? Tapak dan plotnya akan dipindahkan ke peta yang diluluskan.',
    return: 'Kembalikan penyerahan ini kepada pemohon. Pemohon akan melihat sebab anda.',
    withdraw: 'Tarik balik penyerahan ini? Tindakan ini tidak boleh dibatalkan.',
    delete: 'Padam penyerahan ini? Ia hilang daripada semua senarai; rekodnya disimpan.',
    resubmit: 'Hantar semula penyerahan ini untuk disemak. Pilih lukisan yang akan disemak.',
    resubmitSame: 'Hantar semula dengan lukisan yang sama',
    resubmitSameHint: 'Lukisan terkini disemak semula sebagai versi seterusnya.',
    resubmitReplace: 'Muat naik lukisan gantian',
    resubmitReplaceHint: 'Lukisan baharu menjadi versi seterusnya.',
    resubmitNoPrevious: 'Tiada lukisan terdahulu untuk digunakan semula, jadi muat naik satu.',
    resubmitStoredHint: 'Lukisan gantian anda sudah dimuat naik, jadi lukisan itulah yang disemak.',
    resubmitUploading: 'Memuat naik lukisan… {{percent}}%',
    resubmitFinalizing: 'Menyemak muat naik…',
    resubmitSubmitting: 'Menghantar semula…',
    reasonLabel: 'Sebab',
    reasonRequired: 'Masukkan sebab.',
    confirm: 'Sahkan',
    cancel: 'Batal',
  },
  guards: {
    form_valid: 'borang belum lengkap',
    documents_cad_present_or_reuse: 'tiada lukisan dimuat naik untuk versi ini',
    submission_current: 'keputusan semakan sudah lapuk',
    submission_latest_errored: 'semakan terkini tidak mengalami ralat',
    check_latest_passed: 'semakan terkini belum lulus',
    register_not_dead: 'daftar peta mempunyai kemas kini yang gagal',
    separation_of_duties: 'pelulus tidak boleh sama dengan penghantar terakhir',
    input_reason_present: 'sebab diperlukan',
    clock_running: 'tempoh untuk langkah ini telah tamat atau tidak berjalan',
    clock_due: 'tempoh belum tamat',
    ...workflowStrings.guards,
  },
  events: {
    case_created: 'Dicipta',
    case_attributes_updated: 'Butiran dikemas kini',
    document_added: 'Lukisan dimuat naik',
    transition_submit: 'Dihantar',
    transition_check_passed: 'Semakan lulus',
    transition_check_failed: 'Semakan gagal',
    transition_check_errored: 'Semakan tidak dapat dijalankan',
    transition_check_retry: 'Semakan dicuba semula',
    transition_resubmit: 'Dihantar semula',
    transition_approve: 'Diluluskan',
    transition_return: 'Dikembalikan',
    transition_withdraw: 'Ditarik balik',
    transition_delete: 'Dipadam',
    case_bound: 'Diikat pada prosedurnya',
    document_reused: 'Lukisan diguna semula',
    clock_started: 'Tempoh bermula',
    clock_paused: 'Tempoh dijeda',
    clock_resumed: 'Tempoh disambung',
    clock_stopped: 'Tempoh dihentikan',
    clock_extended: 'Tempoh dilanjutkan',
    clock_expired: 'Tempoh tamat',
    clock_scheduled: 'Tarikh akhir ditetapkan',
    ...exportStrings.events,
    ...importStrings.events,
    ...workflowStrings.events,
    ...intakeStrings.events,
  },
  attributes: {
    keterangan: 'Keterangan',
    gtn1: 'Guna tanah (GTN1)',
    gtn2: 'Guna tanah (GTN2)',
    gtn3: 'Guna tanah (GTN3)',
    nama: 'Nama',
    pemajuan: 'Pemajuan',
    pemaju: 'Pemaju',
    no_fail: 'No. fail',
    luas_hektar: 'Luas (hektar)',
    negeri: 'Negeri',
    daerah: 'Daerah',
    mukim: 'Mukim',
    no_lot: 'No. lot',
    tahun_data: 'Tahun data',
    jenis_km: 'Jenis KM',
    kaedah: 'Kaedah penyerahan OSC',
    upi: 'Pengecam unik lot (UPI)',
  },
  map: {
    empty: 'Belum ada geometri untuk dipratonton.',
    legendClasses: 'Guna tanah',
    legendStatus: 'Status',
    statusApproved: 'Diluluskan',
    statusStaging: 'Staging',
    statusCandidate: 'Calon (untuk diagnosis sahaja)',
    unclassified: 'Tidak dikelaskan',
  },
  timeline: {
    system: 'Sistem',
    empty: 'Belum ada peristiwa.',
    reason: 'Sebab: {{reason}}',
    stageChange: '{{from}} → {{to}}',
  },
  register: registerPublic,
  errors: {
    stale_case: 'Penyerahan ini telah berubah sejak anda membukanya. Ia telah dimuat semula; cuba lagi.',
    stage_locked: 'Penyerahan ini tidak boleh disunting pada peringkat semasa.',
    guard_failed: 'Belum boleh dilakukan: {{guards}}.',
    actor_not_permitted: 'Anda tidak dibenarkan melakukannya.',
    not_planning_actor:
      'Anda tiada peranan Perancangan. Minta pentadbir menambah anda ke kumpulan penyemak atau pelulus.',
    request_id_reused: 'Permintaan itu telah digunakan untuk tindakan lain. Muat semula dan cuba lagi.',
    upload_rejected: 'Lukisan ditolak ({{reason}}).',
    register_server_not_configured: 'Tiada pelayan daftar peta dikonfigurasikan.',
    register_server_locked: 'Pelayan daftar peta tidak boleh ditukar setelah penyerahan wujud.',
    invalid_settings: 'Sesetengah tetapan tidak sah. Betulkan item di bawah dan simpan semula.',
    invalid_register_server: 'Pelayan daftar peta yang dipilih tidak sah.',
    registration_closed: 'Pendaftaran pemohon ditutup.',
    rate_limited: 'Terlalu banyak permintaan. Tunggu beberapa minit dan cuba lagi.',
    registration_not_found: 'Pendaftaran itu tidak ditemui.',
    registration_not_pending: 'Pendaftaran itu telah diputuskan.',
    identity_exists: 'Akaun dengan e-mel ini sudah wujud.',
    email_in_use: 'E-mel ini digunakan oleh akaun dalam organisasi lain.',
    seats_exhausted: 'Tiada slot pengguna yang tinggal untuk jenis akaun ini.',
    seats_busy: 'Akaun lain sedang dicipta. Cuba lagi sebentar lagi.',
    invalid_registration: 'Sesetengah butiran pendaftaran tidak sah.',
    document_not_found: 'Fail itu tidak tersedia untuk versi ini.',
    invalid_calendar: 'Kalendar itu tidak sah. Betulkan item yang disenaraikan di bawah dan cuba lagi.',
    invalid_overlay: 'Pelarasan ini tidak sah. Betulkan item yang disenaraikan di bawah dan simpan semula.',
    settings_required: 'Simpan tetapan Perancangan dahulu, kemudian laraskan prosedur.',
    procedure_variant_unavailable:
      'Pelarasan prosedur yang digunakan tidak dapat dimuatkan. Pentadbir perlu menyimpannya semula atau kembali kepada prosedur yang diterbitkan dalam Tetapan → Perancangan.',
    no_decision_tables: 'Prosedur ini tiada jadual peraturan untuk dimuat turun.',
    openSettings: 'Buka tetapan Perancangan',
    not_found: 'Tidak ditemui, atau anda tidak boleh melihatnya.',
    network: 'Tidak dapat menghubungi pelayan. Semak sambungan anda dan cuba lagi.',
    upload_aborted: 'Muat naik dibatalkan.',
    upload_transport: 'Muat naik gagal. Cuba lagi.',
    generic: 'Sesuatu tidak kena. Cuba lagi.',
    retryLoad: 'Cuba lagi',
    ...exportStrings.errors,
    ...importStrings.errors,
    ...queueStrings.errors,
    ...workflowStrings.errors,
    ...intakeStrings.errors,
    ...registerExportStrings.errors,
    ...notificationStrings.errors,
    ...lettersStrings.errors,
  },
} as const
